import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Console } from 'console';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppServiceManager } from 'common/services/appServiceManager';
import { Configuration } from 'config/config';
import { IBranch } from '../../Domains/branch';
import { ICompany } from '../../Domains/company';
import { IEmailFields } from '../../Domains/emailFields';
import { IMemberFeeDetails } from '../../Domains/feeDetail';
import { IMember } from '../../Domains/member';
import { IPackageBuider } from '../../Domains/packageBuilder';
import { LanguageService } from 'app/LanguageService/Language.Service';
import { IUser } from 'app/shared/Domains/IUser';
import { AuthService } from 'common/services/auth.service';
import { collectFbrInvoiceIds, fbrDiLogoAbsoluteUrl, fbrQrItems, FbrReceiptItem } from 'common/services/fbr-receipt.util';
@Component({
	selector: 'app-receipt-print',
	templateUrl: './receipt-print.component.html',
	styleUrls: ['./receipt-print.component.css']
})
export class ReceiptPrintComponent implements OnInit {

	@Input() company: ICompany;
	@Input() branch: IBranch;
	@Input() members: IMemberFeeDetails[];
	@Input() fundInvoice: any;
	@Input() subPackage: any;
	@Input() invoicePrint: boolean;
	@Input() totalPackageFee: number;
	@Input() totalReceivedFee: number;
	@Input() noofMonths: number;
	@Input() noOfMembers: number;
	@Input() totalRegistrationPackageFee: number;
	@Input() registrationDiscount: number;
	@Input() monthlyDiscount: number;
	@Input() trainerDiscount: number;
	@Input() totalTrainerFee: number;
	@Input() email: IEmailFields;
	@Input() taxRate: number;
	@Input() taxType: string;
	@Input() paymentMode: string;
	@Output() closeEmailConfirmation = new EventEmitter<any>();
	@Output() sendingBackhtmlToPdf = new EventEmitter<any>();
	@Input() printInvoiceMembers: IMember[];
	htmlToPdf: any;
	loading: boolean = false;
	invoiceData: any;
	user: IUser;
	invoiceMessage: any;
	isDiscountFormulaReverse: boolean
	fbrLogoUrl = '';
	memberFbrItems: FbrReceiptItem[][] = [];
	// totalTax: number = 0;

	constructor(private LanguageService: LanguageService, public config: Configuration, private loader: NgxSpinnerService, private appServiceManager: AppServiceManager, private confirmationService: ConfirmationService, private messageService: MessageService) { }
	setLabel(label) {
		return this.LanguageService.GetCurrentLanguage("ReceiptPrintComponent", label);
	  }
	ngOnInit() {
		this.members;
		this.isDiscountFormulaReverse = this.branch?.permissions?.isDiscountFormulaReverse
		this.invoiceData = this.branch.invoiceData;
		this.invoiceMessage= this.branch?.invoiceData?.invoiceMessage;
		this.user = new IUser();
		this.user = AuthService.getLoggedInUser();

	}

	// calculateTotalTax() {
	// 	this.totalTax = 0;
	// 	this.printInvoiceMembers.forEach(member => {
	// 		member.feeDetails.forEach(fee => {
	// 				const tax = parseFloat(((fee.pay - fee.discount) * this.taxRate / 100.0).toFixed(2));
	// 				this.totalTax += tax;
	// 		});
	// 	});
	// 	return parseFloat(this.totalTax.toFixed(2));
	// }



	getFeeAfterTaxAndDiscount(member, status) {
		let returnValue = 0;
		const fees = member.feeDetails.filter(fee => fee.status === status);
		if (fees.length > 0) {
			fees.forEach(fee => {
				const pay = Number(fee.pay);
				const discount = Number(fee.discount);
				if (this.taxType === "WITH_TAX") {
                let tax = 0;
                let calculatedFee = 0;

                if (this.isDiscountFormulaReverse) {
                    tax = parseFloat((pay == discount ? 0 : (pay * this.taxRate / 100.0)).toFixed(0));
                    calculatedFee = parseFloat(((pay - discount) + tax).toFixed(0));
                } else {
                    tax = parseFloat(((pay - discount) * this.taxRate / 100.0).toFixed(0));
                    calculatedFee = parseFloat(((pay - discount) + tax).toFixed(0));
                }

                returnValue += calculatedFee;
				} else {
					const calculatedFee = parseFloat((pay - discount).toFixed(0));
					returnValue += calculatedFee;
				}
			});
		}
		return parseFloat(returnValue.toFixed(0));
	}

	getGrandTotalAfterTaxAndDiscount(member) {
		const registrationFee = this.getFeeAfterTaxAndDiscount(member, "Registration Fee - Paid");
		const monthlyFee = this.getFeeAfterTaxAndDiscount(member, "Monthly Fee - Paid");
		const trainerFee = this.getFeeAfterTaxAndDiscount(member, "Trainer Fee - Paid");
		const returnValue = registrationFee + monthlyFee + trainerFee;
		return parseFloat(returnValue.toFixed(0));
	}

	hasDiscount(member: IMember): boolean {
		if (!member || !member.feeDetails) {
			return false;
		}
		return member.feeDetails.some(fee => Number(fee.discount || 0) > 0);
	}
	hasFeeDiscount(feeDetails: IMemberFeeDetails[], status: string): boolean {
    if (!feeDetails || !Array.isArray(feeDetails)) {
        return false;
    }

    return feeDetails.some(
        fee => fee.status === status && Number(fee.discount || 0) > 0
    );
}

	printInvoice() {
		console.log(this.email);
		void this.prepareFbrThenPrint();
	}

	private async prepareFbrThenPrint(): Promise<void> {
		const grouped: FbrReceiptItem[][] = [];
		for (const member of this.printInvoiceMembers || []) {
			const ids: string[] = [];
			for (const fee of member?.feeDetails || []) {
				ids.push(...collectFbrInvoiceIds(fee));
			}
			grouped.push(await fbrQrItems(ids));
		}
		this.memberFbrItems = grouped;
		this.fbrLogoUrl = grouped.some((items) => items.length > 0) ? fbrDiLogoAbsoluteUrl() : '';
		this.invoiceData = this.branch.invoiceData;
		setTimeout(() => {
			this.print();
		}, 300);
	}

	dialogClose(){
		this.closeEmailConfirmation.emit();
	}

	print(): void {
		this.invoiceData = this.branch.invoiceData;
		let currentDate=new Date();
		this.branch.name= this.branch.name+ " " + currentDate.getDate()+ "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getFullYear();
		let printContents, popupWin;
		printContents = document.getElementById('invoice').innerHTML;
		// if (parseInt(this.member.registerationFee) > 0) {
		//   printContents += document.getElementById('invoice2').innerHTML
		// }
		popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
		popupWin.document.open();
		popupWin.document.write(`
    <html>
    <head>
        <title>${this.branch.name}</title>
        <style>
			.invoice-box {
				max-width: 800px;
				margin: auto;
				padding: 25px;
				border: 1px solid #eee;
				box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
				font-size: 16px;
				line-height: 24px;
				font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
				color: #555;
			}

			.invoice-box table {
				width: 100%;
				line-height: inherit;
				/* text-align: left; */
			}

			.invoice-box table td {
				padding: 5px;
				vertical-align: top;
			}

			.invoice-box table tr td:nth-child(n + 2) {
				text-align: right;
			}

			.invoice-box table tr.top table td.title {
				font-size: 45px;
				line-height: 45px;
				color: #333;
			}

			.invoice-box table tr.heading td {
				background: #eee;
				border-bottom: 1px solid #ddd;
				font-weight: bold;
			}

			.invoice-box table tr.details td {
				padding-bottom: 20px;
			}

			.invoice-box table tr.item td {
				border-bottom: 1px solid #eee;
			}
			.invoice-box table tr.item.last td {
				border-bottom: none;
			}
			.invoice-box table tr.item input {
				padding-left: 5px;
			}
			.invoice-box table tr.item td:first-child input {
				margin-left: -5px;
				width: 100%;
			}
			.invoice-box table tr.total td:nth-child(2) {
				border-top: 2px solid #eee;
				font-weight: bold;
			}
			.invoice-box input[type="number"] {
				width: 60px;
			}
			.heading td {
				font-size: 13px;
			}
			.item td {
				font-size: 13px;
			}
			@media only screen and (max-width: 600px) {
				.invoice-box table tr.top table td {
					width: 100%;
					display: block;
					text-align: center;
				}

				.invoice-box table tr.information table td {
					width: 100%;
					display: block;
					text-align: center;
				}
			}
			.rtl {
				direction: rtl;
				font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
					sans-serif;
			}
			.rtl table {
				text-align: right;
			}
			.rtl table tr td:nth-child(2) {
				text-align: left;
			}
			@media print {
				logoDiv {
					page-break-after: always;
				}
			}
		</style>
    </head>
    <body>${printContents}</body>
    </html>
    `
		);
	}

	getHtml() {
		let printContents;
		printContents = document.getElementById('invoice').innerHTML;
		let htmlToPdf = `<html>
		<head>
			 <title>Gym Invoice</title>
			 <style>
				  .invoice-box {
						max-width: 800px;
						margin: auto;
						padding: 30px;
						border: 1px solid #eee;
						box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
						font-size: 16px;
						line-height: 24px;
						font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
						color: #555;
				  }

				  .invoice-box table {
						width: 100%;
						line-height: inherit;
						text-align: left;
				  }

				  .invoice-box table td {
						padding: 5px;
						vertical-align: top;
				  }

				  .invoice-box table tr td:nth-child(n + 2) {
						text-align: right;
				  }

				  .invoice-box table tr.top table td {
						padding-bottom: 20px;
				  }

				  .invoice-box table tr.top table td.title {
						font-size: 45px;
						line-height: 45px;
						color: #333;
				  }

				  .invoice-box table tr.information table td {
						padding-bottom: 40px;
				  }

				  .invoice-box table tr.heading td {
						background: #eee;
						border-bottom: 1px solid #ddd;
						font-weight: bold;
				  }

				  .invoice-box table tr.details td {
						padding-bottom: 20px;
				  }

				  .invoice-box table tr.item td {
						border-bottom: 1px solid #eee;
				  }
				  .invoice-box table tr.item.last td {
						border-bottom: none;
				  }
				  .invoice-box table tr.item input {
						padding-left: 5px;
				  }
				  .invoice-box table tr.item td:first-child input {
						margin-left: -5px;
						width: 100%;
				  }
				  .invoice-box table tr.total td:nth-child(2) {
						border-top: 2px solid #eee;
						font-weight: bold;
				  }
				  .invoice-box input[type="number"] {
						width: 60px;
				  }
				  @media only screen and (max-width: 600px) {
						.invoice-box table tr.top table td {
							 width: 100%;
							 display: block;
							 text-align: center;
						}

						.invoice-box table tr.information table td {
							 width: 100%;
							 display: block;
							 text-align: center;
						}
				  }
				  .rtl {
						direction: rtl;
						font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
							 sans-serif;
				  }
				  .rtl table {
						text-align: right;
				  }
				  .rtl table tr td:nth-child(2) {
						text-align: left;
				  }
			 </style>
		</head>
		<body>${printContents}</body>
		</html>`

		return htmlToPdf;

	}

	getEmailBodyHtml(){
		let printContents;
		printContents = document.getElementById('invoice1').innerHTML;
		this.htmlToPdf = `<html>
		<body>${printContents}</body>
		</html>`
		this.sendingBackhtmlToPdf.emit(this.htmlToPdf)

	}

	sendInvoiceEmailAsPdf() {
		let htmlToPdf = this.getHtml();
		this.confirmationService.confirm({
			message: "Are you sure you want to proceed?",
			accept: () => {
				this.loader.show();
				this.loading = true;
				this.appServiceManager.post('customers/sendEmailWhileInvoicReceiptePrint',
					{
						data: htmlToPdf,
						invoiceDay: this.fundInvoice.date,
						subject: this.email.subject,
						body: this.email.body,
						to: this.email.to,
						company: this.company.name

					}).subscribe((res) => {
						this.loading = false;
						this.loader.hide();
						this.dialogClose();
						this.messageService.clear();
						this.messageService.add({ severity: 'success', summary: 'Success Message', detail: "Attachment Sent Successfully!" });
					},
						(error) => {
							this.loading = false;
							this.loader.hide();
							this.dialogClose();
							this.messageService.clear();
							this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
						}
					)
			}
		});
	}
}
